import { render, staticRenderFns } from "./case-edit.vue?vue&type=template&id=295bdc1c&scoped=true"
import script from "./case-edit.vue?vue&type=script&lang=js"
export * from "./case-edit.vue?vue&type=script&lang=js"
import style0 from "./case-edit.vue?vue&type=style&index=0&id=295bdc1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295bdc1c",
  null
  
)

export default component.exports